import React, { useState } from 'react';
import type { AuthDeviceOption } from '../../auth/types';
import './auth-ui.css';

interface Props {
  message: string;
  devices: AuthDeviceOption[];
  disabled?: boolean;
  onContinue: (sessionId: string) => void;
  onDismiss: () => void;
}

const DeviceLimitPanel: React.FC<Props> = ({
  message,
  devices,
  disabled = false,
  onContinue,
  onDismiss,
}) => {
  const [selectedId, setSelectedId] = useState(devices[0]?.sessionId ?? '');
  const activeId = devices.some((device) => device.sessionId === selectedId)
    ? selectedId
    : devices[0]?.sessionId ?? '';

  return (
    <div className="device-limit" role="alert">
      <p className="device-limit__title">This account is already signed in</p>
      <p className="device-limit__message">
        {message} Continue here signs out the device you pick.
      </p>
      <ul className="device-limit__list">
        {devices.map((device) => (
          <li key={device.sessionId}>
            <label className="device-limit__option">
              <input
                type="radio"
                name="replace-device"
                checked={activeId === device.sessionId}
                disabled={disabled}
                onChange={() => setSelectedId(device.sessionId)}
              />
              <span>{device.label}</span>
            </label>
          </li>
        ))}
      </ul>
      <div className="device-limit__actions">
        <button
          type="button"
          className="device-limit-continue"
          disabled={disabled || !activeId}
          onClick={() => onContinue(activeId)}
        >
          Continue on this browser
        </button>
        <button
          type="button"
          className="device-limit-dismiss"
          disabled={disabled}
          onClick={onDismiss}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DeviceLimitPanel;
